/* ARRAY - "ARRAY Rewards" floating launcher + guide panel. 29 Sep 2026.
   Data comes from snippets/beyondads-rewards-launcher.liquid (#ba-rw-data); styles in
   assets/beyondads-rewards-launcher.css. Three states - guest / joined / member - are
   described at the top of the snippet. The button and panel are appended to <body> so no
   section or template has to know about them. Esc, the x, or a click outside closes it. */
(function () {
  'use strict';
  if (window.__baRw) return;
  window.__baRw = true;

  var TIERS = [[100, 3], [200, 6], [300, 10], [500, 18], [750, 30]];
  var WELCOME_DAYS = 60;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var I = {
    gift: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><rect x="2.5" y="7" width="15" height="3.6" rx=".8"/><path d="M4 10.6V17h12v-6.4M10 7v10M10 7S8.9 3 6.6 3.4C4.8 3.7 5.3 7 10 7Zm0 0s1.1-4 3.4-3.6C15.2 3.7 14.7 7 10 7Z"/></svg>',
    x: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8"/></svg>',
    tag: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M8.6 1.8H14v5.4L7.4 13.8a1 1 0 0 1-1.4 0L2.2 10a1 1 0 0 1 0-1.4Z"/><circle cx="11" cy="4.8" r="1"/></svg>',
    people: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><circle cx="5.5" cy="5" r="2.3"/><circle cx="11.2" cy="5.8" r="1.8"/><path d="M1.5 13.5c.4-2.4 2-3.8 4-3.8s3.6 1.4 4 3.8M10 9.8c2 0 3.6 1.1 4 3.4"/></svg>',
    cake: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M2.5 14V8.5h11V14M1.5 14h13M2.5 11c1.4 0 1.4-1 2.75-1S6.6 11 8 11s1.4-1 2.75-1 1.35 1 2.75 1M8 8.5V6"/><path d="M8 2.2c.9 1 .9 2 0 2.6-.9-.6-.9-1.6 0-2.6Z"/></svg>'
  };

  function next(points) {
    for (var i = 0; i < TIERS.length; i++) {
      if (points < TIERS[i][0]) return { need: TIERS[i][0], off: TIERS[i][1], prev: i ? TIERS[i - 1][0] : 0 };
    }
    return null;
  }
  function best(points) {
    var b = null;
    for (var i = 0; i < TIERS.length; i++) if (points >= TIERS[i][0]) b = TIERS[i];
    return b;
  }

  function guest(D) {
    return '' +
      '<p class="baw-eye">ARRAY Rewards</p>' +
      '<h2 class="baw-h" id="baw-title">Good things come <em>back.</em></h2>' +
      '<p class="baw-p">Collect points on every order and turn them into money off and free gifts.</p>' +
      '<ol class="baw-steps">' +
        '<li><span><b>Join free</b><span class="t">20 points the moment you sign up.</span></span></li>' +
        '<li><span><b>Shop as usual</b><span class="t">Every $1 you spend earns 1 point.</span></span></li>' +
        '<li><span><b>Treat yourself</b><span class="t">$3 off at 100 points, all the way up to $30 off.</span></span></li>' +
      '</ol>' +
      '<div class="baw-chips">' +
        '<div class="baw-chip"><b>10%</b>for you and a friend you invite</div>' +
        '<div class="baw-chip"><b>+50</b>points on your birthday</div>' +
      '</div>' +
      '<a class="baw-cta" href="' + esc(D.login) + '">Join free</a>' +
      '<p class="baw-fine">Already a member? <a href="' + esc(D.login) + '">Sign in</a> &middot; <a href="' + esc(D.rewards) + '">How it works</a></p>';
  }

  function joined(D, w) {
    var em = w.e ? '<b>' + esc(w.e) + '</b>' : 'your email';
    return '' +
      '<p class="baw-eye">You&rsquo;re in</p>' +
      '<h2 class="baw-h" id="baw-title">Welcome to <em>ARRAY.</em></h2>' +
      '<p class="baw-p">Your 10% code and 20 points are saved to ' + em + '.</p>' +
      '<div class="baw-code"><span><small>Your 10% code</small><strong>' + esc(w.c) + '</strong></span>' +
        '<button type="button" class="baw-copy" data-baw-copy="' + esc(w.c) + '">Copy</button></div>' +
      '<ol class="baw-steps">' +
        '<li><span><b>Shop anything</b><span class="t">Check out with ' + em + ' and the 10% comes off.</span></span></li>' +
        '<li><span><b>Sign in to see your points</b><span class="t">Use ' + em + '. You&rsquo;ll see your points, your rewards and your own invite link.</span></span></li>' +
        '<li><span><b>Invite your friends</b><span class="t">They get 10% off. You get 10% off when they order.</span></span></li>' +
      '</ol>' +
      '<a class="baw-cta" href="' + esc(D.login) + '">Sign in to see my points</a>';
  }

  function member(D) {
    var p = D.points || 0, n = next(p), b = best(p), bar = 100, line;
    if (n) {
      bar = Math.max(4, Math.round((p - n.prev) * 100 / (n.need - n.prev)));
      line = '<b>' + (n.need - p) + ' more points</b> and you unlock $' + n.off + ' off.';
      if (b) line = '<b>$' + b[1] + ' off is ready to use.</b> ' + (n.need - p) + ' more points for $' + n.off + ' off.';
    } else {
      line = '<b>Every reward is unlocked.</b> Pick one on your rewards page.';
    }
    var h = '' +
      '<p class="baw-eye">ARRAY Rewards</p>' +
      '<h2 class="baw-h" id="baw-title">' + (D.name ? 'Hi ' + esc(D.name) + '.' : 'Your rewards.') + '</h2>' +
      '<div class="baw-bal">' +
        '<p class="baw-bal-n"><b>' + p + '</b><small>points</small></p>' +
        '<div class="baw-track" role="presentation"><i style="width:' + bar + '%"></i></div>' +
        '<p>' + line + '</p>' +
        (D.pending > 0 ? '<p class="pend">+ ' + D.pending + ' points on the way. They unlock when your order is delivered.</p>' : '') +
      '</div>';
    if (D.thanks) {
      h += '<div class="baw-thx"><p>A friend you invited just ordered. Here&rsquo;s 10% off your next order.' +
        '<small>' + esc(D.thanks) + ' &middot; one use</small></p>' +
        '<a href="/discount/' + encodeURIComponent(D.thanks) + '?redirect=/cart">Use it</a></div>';
    }
    h += '<ul class="baw-steps baw-steps--icons">' +
      '<li><span class="baw-ic">' + I.tag + '</span><span><b>' + (b ? 'Spend your points' : 'Your first reward') + '</b>' +
        '<span class="t">' + (b ? 'Pick money off or a free gift on your rewards page. One reward per order.' : 'Unlocks at 100 points: $3 off. Every $1 you spend earns 1 point.') + '</span></span></li>' +
      (D.link ? '<li><span class="baw-ic">' + I.people + '</span><span><b>Invite a friend</b>' +
        '<span class="t">They get 10% off their first order. You get 10% off when they order.</span>' +
        '<span class="baw-link"><input type="text" readonly value="' + esc(D.link) + '" aria-label="Your invite link">' +
        '<button type="button" class="baw-copy" data-baw-copy="' + esc(D.link) + '">Copy</button></span></span></li>' : '') +
      (!D.bday ? '<li><span class="baw-ic">' + I.cake + '</span><span><b>Add your birthday</b>' +
        '<span class="t">+50 points on the day, every year. <a href="' + esc(D.rewards) + '#rw-bday">Add it</a></span></span></li>' : '') +
      '</ul>' +
      '<a class="baw-cta" href="' + esc(D.rewards) + '">See my rewards</a>';
    return h;
  }

  function copy(btn) {
    var text = btn.getAttribute('data-baw-copy') || '';
    var done = function () {
      btn.textContent = 'Copied';
      btn.classList.add('is-done');
      clearTimeout(btn.__t);
      btn.__t = setTimeout(function () { btn.textContent = 'Copy'; btn.classList.remove('is-done'); }, 1800);
    };
    var fallback = function () {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, 99999);
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      ta.remove();
      if (ok) done();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, fallback);
    } else {
      fallback();
    }
  }

  function boot() {
    var el = document.getElementById('ba-rw-data');
    if (!el || document.querySelector('.baw-btn')) return;
    var D;
    try { D = JSON.parse(el.textContent); } catch (e) { return; }

    var w = null;
    if (!D.signed) {
      try {
        var s = JSON.parse(localStorage.getItem('array_welcome') || 'null');
        if (s && s.c && Date.now() - (s.t || 0) < WELCOME_DAYS * 864e5) w = s;
      } catch (e) {}
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'baw-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'baw-panel');
    btn.innerHTML = I.gift + '<span><span class="baw-long">ARRAY </span>Rewards</span>' +
      (D.signed ? '<span class="baw-pts" aria-label="' + (D.points || 0) + ' points">' + (D.points || 0) + '</span>' :
        (w ? '<span class="baw-dot" aria-hidden="true"></span>' : ''));

    var panel = document.createElement('div');
    panel.className = 'baw-panel';
    panel.id = 'baw-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-labelledby', 'baw-title');
    panel.tabIndex = -1;
    panel.innerHTML = '<button type="button" class="baw-x" aria-label="Close">' + I.x + '</button>' +
      (D.signed ? member(D) : (w ? joined(D, w) : guest(D)));

    document.body.appendChild(panel);
    document.body.appendChild(btn);

    function open() {
      panel.classList.add('is-open');
      document.documentElement.classList.add('baw-open');
      btn.setAttribute('aria-expanded', 'true');
      try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
    }
    function close(back) {
      if (!panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      document.documentElement.classList.remove('baw-open');
      btn.setAttribute('aria-expanded', 'false');
      if (back) btn.focus();
    }
    btn.addEventListener('click', function () {
      if (panel.classList.contains('is-open')) close(false); else open();
    });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('.baw-x')) { close(true); return; }
      var c = e.target.closest('[data-baw-copy]');
      if (c) { e.preventDefault(); copy(c); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close(true);
    });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && !btn.contains(e.target)) close(false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
